import privacyPath from "@faire/web-api/routes/privacy";
import tosPath from "@faire/web-api/routes/tos";
import tosBrandPath from "@faire/web-api/routes/tos-brand";
import { Typography } from "@faire/web/slate/Typography";
import { EmbeddedLink } from "@faire/web/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { type JSX } from "react";
import styled from "styled-components";

export const AcceptTermsMessage: React.FC = () => (
  <Typography>
    <StrictLocalMsg
      defaultMessage="By proceeding, you're agreeing to Faire's <TosLinkFormatting>Terms of Service</TosLinkFormatting>, <BrandLinkFormatting>Brand Agreement</BrandLinkFormatting>, and <PrivacyLinkFormatting>Privacy Policy</PrivacyLinkFormatting>."
      values={{
        TosLinkFormatting,
        BrandLinkFormatting,
        PrivacyLinkFormatting,
      }}
      description={{
        text: "Label for the checkbox users check to agree to faire's Terms of Service",
      }}
    />
  </Typography>
);

const StyledLink = styled(EmbeddedLink).attrs({
  target: "_blank",
})`
  color: inherit;
  text-decoration-color: inherit;
`;

const TosLinkFormatting = (chunks: JSX.Element) => (
  <StyledLink linkTo={tosPath()}>{chunks}</StyledLink>
);
const BrandLinkFormatting = (chunks: JSX.Element) => (
  <StyledLink linkTo={tosBrandPath()}>{chunks}</StyledLink>
);
const PrivacyLinkFormatting = (chunks: JSX.Element) => (
  <StyledLink linkTo={privacyPath()}>{chunks}</StyledLink>
);
